import React, { useState } from "react";
import { Box, Button } from "@mui/material";
import "../../estilo/App.css";
import ModalInforme from "../modales/ModalInforme";

const BtnInforme = () => {
  const [openModal, setOpenModal] = useState(false);
  const handleOpenModal = () => {
    setOpenModal(true);
  };  

  const handleCloseModal = () => {
    setOpenModal(false);
  };

  return (
    <Box>
      <Box>
        <Button sx={{ mt: 2 }} variant="outlined" onClick={handleOpenModal}>
          Descargar/Enviar
        </Button>
      </Box>
      <ModalInforme open={openModal} handleClose={handleCloseModal} />
    </Box>
  );
};

export default BtnInforme;
